export default "__VITE_ASSET__CnKTOhBk__"